import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      if (e.response?.status && e.response.status !== 401) console.error("auth/me failed:", e);
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("tkd_token")) refresh();
    else {
      setUser(false);
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tkd_token", data.token);
    setUser(data.user);
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("tkd_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("tkd_token");
    setUser(false);
  };

  const applyAuth = (token, u) => {
    localStorage.setItem("tkd_token", token);
    setUser(u);
  };

  const value = useMemo(
    () => ({ user, setUser, loading, login, register, logout, refresh, applyAuth }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, loading],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
